import PropTypes from 'prop-types';
import moment from "moment-timezone";
import { find } from "lodash"

// All fields optional, but combinations are required for certain topic types. See com.chatmeter.api.google.models.localPosts.LocalPost.scala.
export const GooglePostShape = PropTypes.shape({
  summary: PropTypes.string,
  eventTitle: PropTypes.string,
  eventStart: PropTypes.any, // Local Date Time (no Timezone)
  eventEnd: PropTypes.any, // Local Date Time (no Timezone)
  offerCouponCode: PropTypes.string,
  offerRedeemOnlineUrl: PropTypes.string,
  offerTermsConditions: PropTypes.string,
  alertType: PropTypes.string,
  callToActionType: PropTypes.string,
  callToActionURL: PropTypes.string
})

export const PostToBePublishedShape = PropTypes.shape({
  text: PropTypes.string,
  scheduledTime: PropTypes.any,
  sendNow: PropTypes.bool,
  publishTo: PropTypes.array,
  attachments: PropTypes.array,
  immediateReply: PropTypes.string,
  googlePost: GooglePostShape
});

export const DefaultProvider = 'Facebook';
export const defaultPost = {
  text: '',
  scheduledTime: moment().tz(moment.tz.guess()),
  sendNow: true,
  publishTo: [],
  attachments: [],
  immediateReply: '',
  googlePost: undefined
};

export function postToPostToBePublished(existingPost) {
  return {
    text: existingPost.details.text,
    scheduledTime: moment(existingPost.scheduledTime),
    sendNow: moment(existingPost.scheduledTime).isSameOrBefore(moment()),
    publishTo: existingPost.publishTo,
    attachments: existingPost.details.attachments,
    immediateReply: !!existingPost.details.immediateReply ? existingPost.details.immediateReply : '',
    googlePost: existingPost.details.googlePost
  };
}

export function getDefaultPost(maybeExistingPost) {
  if (!!maybeExistingPost) return postToPostToBePublished(maybeExistingPost);
  else return defaultPost;
}